<div class="float-start me-2">
  <button
    psUiButton
    class="dropdown-toggle header-div-h6 position-relative header-dropdown"
    [class.show]="!showLabel"
    color="secondary"
    (click)="labelToggle()"
  >
    Processing
  </button>
  <p *ngIf="showLabel" class="m-0">
    {{ label }}
  </p>
  <section *ngIf="!showLabel">
    <span class="fw-bold"> Real Time </span>
    <ps-ui-slider
      class="px-1"
      [selected]="manualProcessing"
      (selectedChange)="changed($event)"
      psUiGtagEvent
      trackOn="change"
      action="processing"
      category="Black_Bar"
      [params]="{ event_label: 'Processing Auto/Manual' }"
    >
    </ps-ui-slider>
    <span class="fw-bold"> Manual </span>
  </section>
</div>
<button class="button" *ngIf="manualProcessing" (click)="save()">
  Save & Process
</button>
